// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js!../../styles/global.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-button {
  width: 20.875rem;
  height: 4.75rem;
  flex-shrink: 0;
  border-radius: 1.375rem;
  font-weight: 600;
}

.primary {
  background: var(--primary);
  transition: ease-in-out 50ms;
  color: #fff;
}

.tertiary {
  color: #777;
  width: 10rem;
  margin: 0 2.15rem;
}

.pressed {
  filter: brightness(85%);
  transition: ease-in-out 100ms;
}

.button-important {
  background: var(--secondary);
  transition: ease-in-out 100ms;
}

.secondary {
  background: var(--alt-button-color);
  transition: ease-in-out 100ms;
}

.button-text-primary {
  color: var(--on-primary);
}

.button-text-secondary {
  color: var(--primary);
  font-weight: 500;
}

.black {
  background: var(--black-button-color);
  transition: ease-in-out 100ms;
}

.button-text-black {
  color: #fff;;
  font-weight: 500;
}

.button-text-alt {
  font-weight: 500;
}

.outlined-button {
  background-color: var(--background-color);
  border: 1px solid var(--text-color);
}

.outlined-button-text {
  color: var(--text-color);
}

.filled-button {
  background: var(--background-color);
}

.outlined-primary-button {
  background-color: transparent;
  border: 1px solid var(--primary);
}

.outlined-secondary-button {
  background-color: transparent;
  border: 1px solid var(--secondary);
}

.button-text-outlined-secondary {
  color: var(--secondary);
}

.custom-button:disabled {
  cursor: not-allowed;
  opacity: 0.4;
  pointer-events: none;
}

.custom-button:disabled:hover {
  filter: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/atoms/button/button.css"],"names":[],"mappings":"AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,mCAAmC;AACrC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd","sourcesContent":["@import '../../styles/global.css';\n\n.custom-button {\n  width: 20.875rem;\n  height: 4.75rem;\n  flex-shrink: 0;\n  border-radius: 1.375rem;\n  font-weight: 600;\n}\n\n.primary {\n  background: var(--primary);\n  transition: ease-in-out 50ms;\n  color: #fff;\n}\n\n.tertiary {\n  color: #777;\n  width: 10rem;\n  margin: 0 2.15rem;\n}\n\n.pressed {\n  filter: brightness(85%);\n  transition: ease-in-out 100ms;\n}\n\n.button-important {\n  background: var(--secondary);\n  transition: ease-in-out 100ms;\n}\n\n.secondary {\n  background: var(--alt-button-color);\n  transition: ease-in-out 100ms;\n}\n\n.button-text-primary {\n  color: var(--on-primary);\n}\n\n.button-text-secondary {\n  color: var(--primary);\n  font-weight: 500;\n}\n\n.black {\n  background: var(--black-button-color);\n  transition: ease-in-out 100ms;\n}\n\n.button-text-black {\n  color: #fff;;\n  font-weight: 500;\n}\n\n.button-text-alt {\n  font-weight: 500;\n}\n\n.outlined-button {\n  background-color: var(--background-color);\n  border: 1px solid var(--text-color);\n}\n\n.outlined-button-text {\n  color: var(--text-color);\n}\n\n.filled-button {\n  background: var(--background-color);\n}\n\n.outlined-primary-button {\n  background-color: transparent;\n  border: 1px solid var(--primary);\n}\n\n.outlined-secondary-button {\n  background-color: transparent;\n  border: 1px solid var(--secondary);\n}\n\n.button-text-outlined-secondary {\n  color: var(--secondary);\n}\n\n.custom-button:disabled {\n  cursor: not-allowed;\n  opacity: 0.4;\n  pointer-events: none;\n}\n\n.custom-button:disabled:hover {\n  filter: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
